import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const phoneApi = createApi({
  reducerPath: "phoneApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    sendPhoneOtp: builder.mutation({
      query: ({ phone }) => ({
        url: `auth/phone/send-otp`,
        method: "POST",
        body: { phone },
      }),
    }),
    verifyPhone: builder.mutation({
      query: ({ start_token, otp }) => ({
        url: `auth/phone/verify`,
        method: "POST",
        body: { start_token, otp },
      }),
    }),
    resendPhone: builder.mutation({
      query: ({ start_token }) => ({
        url: `auth/phone/resend`,
        method: "POST",
        body: { start_token },
      }),
    }),
  }),
});

export const {
  useSendPhoneOtpMutation,
  useVerifyPhoneMutation,
  useResendPhoneMutation,
} = phoneApi;
